import {
  Stack,
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React from "react";
import {
  blackShade19,
  borderTextBoxColor,
  greenStatusColor01,
  greyColor060,
  greyColor53,
  greyColor56,
  lightgreenColor04,
  lightOrange04,
  orangeColor03,
  whiteColor,
} from "../../../configs/styles/muiThemes";
import { TOP_CUSTOMER_TABLE_DATA } from "../../../utils/data";
import ProfileCharAvatar from "../../../components/ProfileCharAvatar";
import moment from "moment";
import { addThousandsSeparator } from "../../../utils/helper";

function TopCustomerSection({ businessCustomers }) {
  return (
    <Stack
      sx={{
        border: "1px solid " + greyColor56,
        borderRadius: "12px",
        pb: 2,
      }}
      minHeight={"100%"}
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        sx={{ p: "12px 14px" }}
      >
        <Typography
          fontSize={13.5}
          fontWeight={600}
          color={blackShade19}
          lineHeight="20px"
        >
          Top Customers
        </Typography>
      </Box>

      <Box sx={styles.tableWrapper}>
        <TableContainer sx={styles.tableContainer} component={Box}>
          <Table>
            <TableHead>
              <TableRow
                sx={{
                  position: "sticky !important",
                  top: 0,
                  backgroundColor: greyColor53,
                  zIndex: 8,
                }}
              >
                {TOP_CUSTOMER_TABLE_DATA?.map((element, i) => (
                  <TableCell key={i + "customer header"} sx={styles.tableCell}>
                    {element}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody sx={{ backgroundColor: whiteColor }}>
              {businessCustomers?.details?.slice(0, 4)?.map((customer) => (
                <TableRow
                  sx={{
                    borderBottom: `1px solid ${borderTextBoxColor}`,
                    verticalAlign: "center",
                  }}
                >
                  <TableCell sx={{ ...styles.tableBodyCell }}>
                    <Box
                      display="flex"
                      alignItems="center"
                      gap="8px"
                      py="1.5px"
                    >
                      <ProfileCharAvatar
                        username={customer?.contactInfo?.name}
                        size="30px"
                        fontSize={10.5}
                        border
                      />
                      <Box>
                        <Typography
                          sx={{
                            fontSize: 11.5,
                            fontWeight: 600,
                            color: blackShade19,
                            lineHeight: "16px",
                          }}
                        >
                          {customer?.contactInfo?.name}
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: 11,
                            fontWeight: 400,
                            color: greyColor060,
                            lineHeight: "16px",
                          }}
                        >
                          Customer since{" "}
                          {moment(customer?.createdOn).format("MMM DD YYYY")}
                        </Typography>
                      </Box>
                    </Box>
                  </TableCell>
                  <TableCell sx={styles.tableBodyCell}>
                    ₹{addThousandsSeparator(customer?.orderInfo?.lastTxnAmount)}
                  </TableCell>
                  <TableCell sx={styles.tableBodyCell}>
                    <Box
                      sx={{
                        fontWeight: 500,
                        fontSize: "12px",
                        color: greenStatusColor01,
                        textAlign: "center",
                        background: lightgreenColor04,
                        padding: "2px 14px",
                        display: "inline-block",
                        borderRadius: "4px",
                        // mt: "4px",
                      }}
                    >
                      {customer.orderInfo?.totalOrder}
                    </Box>
                  </TableCell>
                  <TableCell sx={styles.tableBodyCell}>
                    <Box
                      sx={{
                        display: "inline-block",
                        fontWeight: 500,
                        fontSize: "12px",
                        color: orangeColor03,
                        textAlign: "center",
                        background: lightOrange04,
                        padding: "2px 10px",
                        borderRadius: "4px",
                        // mt: "4px",
                      }}
                    >
                      ₹{addThousandsSeparator(customer.orderInfo?.totalAmount)}
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Stack>
  );
}

export default TopCustomerSection;

const styles = {
  tableWrapper: {
    width: "100%",
    // borderRadius: "8px",
    borderTop: `1px solid ${borderTextBoxColor}`,
    borderBottom: "none",
    overflow: "hidden",
  },

  tableContainer: {
    // borderRadius: "8px",
    maxWidth: "100%",
    "&::-webkit-scrollbar": {
      width: "4px",
      height: "4px",
      borderRadius: "50px !important",
    },
    "&::-webkit-scrollbar-thumb": {
      // background: '#d0d3da',
      background: "rgba(0,0,0,0.1)",
    },
    "&::-webkit-scrollbar-track": {
      background: "rgba(0,0,0,0.05)",
    },
  },

  tableCell: {
    color: greyColor060,
    fontSize: "12px",
    fontWeight: "400",
    lineHeight: "16px",
    whiteSpace: "nowrap",
    padding: "8px 15px",
    backgroundColor: greyColor53,
    textAlign: "start",
    // borderRight: `1px solid ${whiteColor}`,
  },

  tableBodyCell: {
    fontSize: 12,
    fontWeight: 600,
    lineHeight: "16px",
    whiteSpace: "nowrap",
    color: blackShade19,
    padding: "10px 15px !important",
    textAlign: "start",
  },
};
